import {drawPin, drawBadge, pinScale, pinSpriteGeometry, badgeWidth} from './pins.mjs';
import {bubbleStyle} from './bubbles.mjs';

// Crop only transparent map-anchor padding; never scale down the actual 90% pin.
export function drawLegendPin(label, color, theme, profile = {}, badge = '', pixelRatio = globalThis.devicePixelRatio || 1) {
  const full = drawPin(label, color, theme, undefined, profile, badge, 0, 1, pixelRatio);
  const scale = pinScale(profile);
  const {width, height, top} = pinSpriteGeometry(scale, badge ? badgeWidth(badge, null, profile) * scale : 0);
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(width * pixelRatio); canvas.height = Math.ceil(height * pixelRatio);
  canvas.style.width = `${width}px`; canvas.style.height = `${height}px`;
  canvas.getContext('2d').drawImage(full, (full.width / 2 - width * pixelRatio / 2), top * pixelRatio,
    width * pixelRatio, height * pixelRatio, 0, 0, width * pixelRatio, height * pixelRatio);
  return canvas;
}
// The map badge on its own, at map scale: one sample row instead of a badge under one pin, so all pin rows share one height.
export function drawLegendBadge(badge, theme, profile = {}, pixelRatio = globalThis.devicePixelRatio || 1) {
  const scale = pinScale(profile), canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
  const width = Math.ceil((badgeWidth(badge, ctx, profile) + 2) * scale), height = Math.ceil(21 * scale);
  canvas.width = Math.ceil(width * pixelRatio); canvas.height = Math.ceil(height * pixelRatio);
  canvas.style.width = `${width}px`; canvas.style.height = `${height}px`;
  ctx.scale(pixelRatio * scale, pixelRatio * scale); drawBadge(ctx, badge, theme, profile, width / scale / 2, 1);
  return canvas;
}
export function drawLegendDot(theme,profile={},pixelRatio=globalThis.devicePixelRatio||1){
  const canvas=document.createElement('canvas');canvas.width=20*pixelRatio;canvas.height=20*pixelRatio;canvas.style.width='20px';canvas.style.height='20px';
  const ctx=canvas.getContext('2d');ctx.scale(pixelRatio,pixelRatio);ctx.beginPath();ctx.arc(10,10,4,0,Math.PI*2);ctx.fillStyle=bubbleStyle('8',theme,profile).fill;ctx.fill();return canvas;
}
// Every row is one pin high; the dot is centred on the pin head.
export function legendGeometry(profile = {}) {
  const scale = pinScale(profile), {top, height} = pinSpriteGeometry(scale);
  return {height, head: 76 - 31 * scale - top};
}
export function renderLegendMarkers(container, labels, theme, profile = {}) {
  container.replaceChildren();
  const {height, head} = legendGeometry(profile);
  container.style.setProperty('--legend-row', `${height}px`); container.style.setProperty('--legend-head', `${head}px`);
  const samples = [['4/4','15'],['2/4','8'],['0/4','0'],['?/4','unknown'],['✕','out'],['','8'],['22 kW']];
  samples.forEach(([label, color], i) => {
    const row = document.createElement('div'), marker = document.createElement('span'), text = document.createElement('span');
    marker.className = 'legend-marker'; marker.setAttribute('aria-hidden', 'true'); text.className = 'legend-label';
    if (i === 6) row.className = 'legend-badge';
    const sample = i === 6 ? drawLegendBadge(label, theme, profile) : i === 5 ? drawLegendDot(theme, profile) : drawLegendPin(label, color, theme, profile);
    if (i === 5) sample.style.marginTop = `${head - parseFloat(sample.style.height) / 2}px`;
    marker.append(sample); text.textContent = labels[i]; row.append(marker, text); container.append(row);
  });
}
